/* TD Draft 2026-09-30 GW — weight guide page (sections/td-weight-guide.liquid, loaded only by that section).
   Product-independent weight finder: Erwachsene / Kinder, blanket size (adults), body-weight slider → the class of the
   section blocks that contains the body weight (adults: both weight ladders, children: weight + sizes).
   - The weight engine (geometry, easing, beads, one-time intro, nudge) is a COPY of assets/td-pdp-weight.js (itself a
     copy of the homepage module), so the PDP module keeps its own behaviour. The drawing has no weight badge and no
     filling label here (this page covers every blanket).
   - The matching row of the reference table is marked (.is-on) so finder and table read together.
   - Reduced motion / Save-Data: no intro, every change instant. The server markup is the complete end state for the start
     values; the result block keeps a reserved height while dragging. Runs once per section (data-td-init); set up again
     after a theme-editor re-render.
   TD Draft 2026-10-01 GW2-1001 — on phones/tablets the drawing now sits right above the slider (inside the card), i.e. on
   screen at load: the one-time intro plays whenever the drawing is in view (at load or later), not only when it starts below
   the viewport. The inline script in the section hides the blanket (class td-wg--arm) until the floating start frame is
   drawn here, so the settled server state never flashes before the intro; reduced motion / Save-Data: no class, no intro.
   TD Draft 2026-10-01 GW2-1001 (review) — the intro waits until the drawing is really visible: half in view AND not covered
   (hit test at the drawing's centre; the Shopify cookie banner or a popup covers it on a first visit). It re-checks every
   400ms while the tab is visible (and right after Shopify's 'visitorConsentCollected'), gives up after 20s of waiting
   (settled state, no intro) and starts over from the floating frame if something covers the drawing early in the settle.
   Script later than 3s after navigation start (slow connection): no intro, the settled state stays (the CSS fallback reveals
   the blanket at 3s). Drape spread over the shop's whole range 3–12 kg, so neighbouring weights land visibly apart.
   Optional (setting, default off): hide the Smart-Bot chat icon on phones while the finder is in view. */
(function () {
  'use strict';
  if (window.tdWeightGuideBooted) return;
  window.tdWeightGuideBooted = true;
  var w = window, d = document, conn = navigator.connection, NB = '\u00a0';
  var mq = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: no-preference)') : null;
  function motionOK() { return !!(mq && mq.matches) && !(conn && conn.saveData); }
  var bags = [], onReduce = [];
  function bag(root) { var b = { r: root, fns: [] }; bags.push(b); return b; }
  if (mq) {
    var mqChange = function () { if (!motionOK()) onReduce.forEach(function (o) { o.f(); }); };
    if (mq.addEventListener) mq.addEventListener('change', mqChange); else if (mq.addListener) mq.addListener(mqChange);
  }
  function once(el, thr, fn, b) {
    if (!('IntersectionObserver' in w)) { fn(); return; }
    var io = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) {
        if (es[i].isIntersecting && es[i].intersectionRatio >= thr * 0.98) { io.disconnect(); fn(); return; }
      }
    }, { threshold: thr });
    io.observe(el);
    if (b) b.fns.push(function () { io.disconnect(); });
  }
  /* GW2-1001 (review): really visible = at least half of it inside the viewport and not covered at its centre (hit test;
     the cookie banner, a popup or a drawer would win the hit test). IntersectionObserver alone ignores overlays. */
  function seen(el) {
    var r = el.getBoundingClientRect(), vw = d.documentElement.clientWidth || w.innerWidth, vh = w.innerHeight;
    var t = Math.max(0, r.top), bt = Math.min(vh, r.bottom), l = Math.max(0, r.left), rt = Math.min(vw, r.right);
    if (bt - t < r.height * 0.5 || rt - l < r.width * 0.5) return false;
    var y = (t + bt) / 2, xs = [l + (rt - l) * 0.3, l + (rt - l) * 0.5];
    for (var i = 0; i < xs.length; i++) {
      var e = d.elementFromPoint(xs[i], y);
      if (!e || !el.contains(e)) return false;
    }
    return true;
  }
  var hashEl = null;
  try { hashEl = w.location.hash.length > 1 ? d.getElementById(decodeURIComponent(w.location.hash.slice(1))) : null; } catch (e) { hashEl = null; }
  /* TD Draft 2026-10-01 GW2-1001 — intro whenever motion is allowed and the drawing is not the target of a deep link; it
     starts once the drawing is half in view (right away when it is on screen at load) */
  function armOK(el) {
    if (!motionOK()) return false;
    return !(hashEl && el.contains(hashEl));
  }
  function nbu(s) { return String(s).replace(/(\d) (kg|cm)(?![\w\u00c0-\u024f])/g, '$1' + NB + '$2').replace(/ × /g, NB + '×' + NB).replace(/ · /g, NB + '·' + NB).replace(/ ›/g, NB + '›'); }
  function tpl(s, o) { return String(s || '').replace(/\[(\w+)\]/g, function (m, k) { return o[k] != null ? o[k] : m; }); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function all(root, sel) { return [].slice.call(root.querySelectorAll(sel)); }

  /* ---------------------------------------------------------------- engine: copy of assets/td-pdp-weight.js */
  var X0 = 70, X1 = 350, N = 64, T = 10, BED = 150, P = 8, PW = (X1 - X0) / P, SVGNS = 'http://www.w3.org/2000/svg';
  var XS = [], HB = [], HL = [];
  function geom() {
    if (XS.length) return;
    var i, j;
    var g = function (x, c, s) { var q = (x - c) / s; return Math.exp(-q * q); };
    for (i = 0; i <= N; i++) { XS.push(X0 + (X1 - X0) * i / N); HB.push(34 * g(XS[i], 100, 34) + 46 * g(XS[i], 192, 50) + 24 * g(XS[i], 288, 46)); }
    for (i = 0; i <= N; i++) { var m = 0; for (j = 0; j <= N; j++) { var q = XS[j] - XS[i]; m = Math.max(m, HB[j] - 0.0035 * q * q); } HL.push(m); }
  }
  /* GW2-1001 (review): depth and beads over the shop's whole range (children 3 kg … adults 12 kg) – in the PDP copy the depth
     is held at its minimum below 5 kg, so 3, 4 and 5 kg looked the same on the children's slider */
  function kOf(kg) { return Math.min(1, Math.max(0.12, 0.12 + (kg - 3) / 9 * 0.88)); }
  function nOf(kg) { return Math.max(2, Math.round(2 + (kg - 3) * 0.55)); }
  function settled(kg) { var k = kOf(kg), a = []; for (var i = 0; i <= N; i++) a.push(BED - (HL[i] + (HB[i] - HL[i]) * k)); return a; }
  function floating() { var a = []; for (var i = 0; i <= N; i++) a.push(74 + 4 * Math.sin(XS[i] / 26)); return a; } /* 52 in the PDP copy: this drawing has no badge/label above the blanket (viewBox from y 54) */
  function yAt(a, x) { var f = (x - X0) / (X1 - X0) * N, i = Math.max(0, Math.min(N - 1, Math.floor(f))), t = f - i; return a[i] + (a[i + 1] - a[i]) * t; }
  function ease(t) { var u = t - 1; return 1 + 1.55 * u * u * u + 0.55 * u * u; } /* soft landing, about 1% overshoot */
  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function r1(v) { return Math.round(v * 10) / 10; }

  function initGuide(root, b) {
    root.classList.add('td-js');
    var data = JSON.parse(root.querySelector('[data-td-wg-data]').textContent);
    var t0 = data.t || {};
    var q = function (s) { return root.querySelector(s); };
    var range = q('[data-wg-range]'), val = q('[data-wg-val]'), res = q('[data-wg-result]'), live = q('[data-wg-live]'),
      cta = q('[data-wg-cta]'), hint = q('[data-wg-hint]'), stage = q('[data-wg-stage]'), blanket = q('[data-wg-blanket]'),
      beadG = q('[data-wg-beads]'), sLabel = q('[data-wg-slabel]'), kNote = q('[data-wg-kids-note]'), notes = q('[data-wg-notes]'),
      sizeBox = q('[data-wg-sizes]'), card = q('[data-wg-slider]') || range; /* GW2-1001: the slider itself (the card is split) */
    if (!range || !res || !cta || !notes || !data.a || !data.k) throw new Error('td-weight-guide: markup');
    var whoIn = all(root, 'input[data-wg-who]'), sizeIn = all(root, 'input[data-wg-size]');
    var stitches = all(root, '[data-wg-stitches] line');
    var mode = 'adults', si = 0, touched = false, introDone = false, recKg = null, lastKey = '', liveKey = '', bootT = Date.now();
    var liveT = 0, visT = 0, chgT = 0, rsT = 0, nudgeT = 0, raf = 0, cur = null, beads = [], nBeads = 0, LT = [], lastW = 0, nudgeWait = false;
    var seed = 7, rnd = function () { seed = (seed * 16807) % 2147483647; return seed / 2147483647; };
    if (!data.a.length) mode = 'kids';

    /* ---- classes */
    function rows() { return mode === 'kids' ? data.k : (data.a[si] ? data.a[si].r : []); }
    function find(list, bw) {
      for (var i = 0; i < list.length; i++) { if (list[i][0] <= bw && bw <= list[i][1]) return i; }
      return -1;
    }
    function kgT(kg) { return String(kg).replace('.', ',') + NB + 'kg'; }
    function rangeT(r) {
      if (r[0] === 0) return (t0.to || '') + ' ' + r[1] + NB + 'kg';
      if (r[1] >= 999) return (t0.from || '') + ' ' + r[0] + NB + 'kg';
      return r[0] + '–' + r[1] + NB + 'kg';
    }
    function compute(bw) {
      var list = rows(), i = find(list, bw), r = i > -1 ? list[i] : null, o = { i: i, r: r, recs: [] };
      if (r) {
        if (mode === 'kids') {
          o.recs.push([r[2], r[3] ? tpl(t0.sizes, { sizes: r[3] }) : '']);
        } else {
          o.recs.push([r[2], tpl(t0.ladder, { kgs: data.la })]);
          if (r[3] != null) o.recs.push([r[3], tpl(t0.ladder, { kgs: data.lb })]);
        }
        o.kg = r[2];
        o.cls = tpl(t0.cls, { range: rangeT(r) });
      }
      o.above = mode === 'kids' && bw >= Number(range.max) && !!t0.above;
      return o;
    }
    function resHTML(o, bw) {
      var h = t0.rec ? '<p class="td-wg__rec-label">' + esc(t0.rec) + '</p>' : '';
      if (!o.r) return h + '<p class="td-wg__none">' + esc(nbu(tpl(t0.none, { bw: bw }))) + '</p>';
      h += '<ul class="td-wg__recs" role="list">' + o.recs.map(function (x) {
        return '<li><strong>' + kgT(x[0]) + '</strong> <span>' + esc(nbu(x[1])) + '</span></li>';
      }).join('') + '</ul>';
      h += '<p class="td-wg__class">' + esc(nbu(o.cls)) + '</p>';
      /* a note for this blanket size (e.g. 150 × 220 cm: own weight classes) */
      if (mode === 'adults' && data.a[si] && data.a[si].n) h += '<p class="td-wg__size-note">' + esc(nbu(data.a[si].n)) + '</p>';
      return h;
    }
    function notesHTML(o) {
      if (!o.above) return '';
      return '<p class="td-wg__note">' + esc(nbu(tpl(t0.above, { next: Number(range.max) + 1 }))) +
        (t0.aboveBtn ? ' <button type="button" class="td-wg__switch" data-wg-to-adults>' + esc(nbu(t0.aboveBtn)) + '</button>' : '') + '</p>';
    }
    /* screen readers: the slider value is announced by aria-valuetext; this line only when the recommendation changes,
       ladders read as "6, 8, 10, 12 kg" instead of the middle dots */
    function liveText(o, bw) {
      var rec = o.r ? o.recs.map(function (x) { return kgT(x[0]) + (x[1] ? ' ' + String(x[1]).replace(/ · /g, ', ') : ''); }).join('; ') : tpl(t0.none, { bw: bw });
      if (mode === 'adults' && data.a[si] && t0.liveSize) return tpl(t0.liveSize, { bw: bw, size: data.a[si].s, rec: rec });
      return tpl(t0.live, { bw: bw, rec: rec });
    }
    /* reserve the tallest result block of the current slider range: the slider and the button stay put while dragging */
    function reserve() {
      var mn = Number(range.min), mx = Number(range.max), seen = {}, hr = 0, keep = res.innerHTML;
      res.style.minHeight = '';
      for (var bw = mn; bw <= mx; bw++) {
        var a = resHTML(compute(bw), bw);
        if (seen[a]) continue;
        seen[a] = 1;
        res.innerHTML = a;
        hr = Math.max(hr, res.offsetHeight);
      }
      res.innerHTML = keep;
      if (hr) res.style.minHeight = hr + 'px';
    }
    function onResize() {
      if (root.offsetWidth === lastW) return;
      clearTimeout(rsT);
      rsT = setTimeout(function () { lastW = root.offsetWidth; reserve(); }, 150);
    }
    function fillBar() {
      var mn = Number(range.min), mx = Number(range.max);
      range.style.setProperty('--p', (mx > mn ? (Number(range.value) - mn) / (mx - mn) * 100 : 0) + '%');
    }
    function markTable(o) {
      var key = (mode === 'kids' ? 'k' : 'a' + si) + ':' + o.i;
      if (key === lastKey) return;
      lastKey = key;
      all(root, '[data-wg-table] tr.is-on').forEach(function (tr) { tr.classList.remove('is-on'); });
      if (o.i < 0) return;
      var tb = q('[data-wg-table="' + (mode === 'kids' ? 'k' : 'a' + si) + '"]');
      var tr = tb && tb.querySelector('tbody tr[data-wg-i="' + o.i + '"]');
      if (tr) tr.classList.add('is-on');
    }
    function render(announce) {
      var bw = Number(range.value), o = compute(bw);
      val.textContent = bw + NB + 'kg';
      range.setAttribute('aria-valuetext', bw + ' kg');
      fillBar();
      res.innerHTML = resHTML(o, bw);
      notes.innerHTML = notesHTML(o);
      markTable(o);
      recKg = o.kg != null ? o.kg : null;
      var key = (mode === 'kids' ? 'k' : 'a' + si) + ':' + o.i;
      if (announce && key !== liveKey) {
        liveKey = key;
        clearTimeout(liveT);
        liveT = setTimeout(function () { live.textContent = liveText(o, bw); }, 450);
      }
      return o;
    }

    /* ---- graphic (copy of assets/td-pdp-weight.js) */
    function buildBeads(n, fall) {
      beadG.textContent = '';
      beads = [];
      for (var p = 0; p < P; p++) {
        for (var bi = 0; bi < n; bi++) {
          var c = d.createElementNS(SVGNS, 'circle');
          c.setAttribute('r', '2.2');
          beadG.appendChild(c);
          beads.push({ p: p, b: bi, n: n, el: c, fx: rnd(), fy: rnd(), fall: fall });
        }
      }
      nBeads = n;
    }
    function frame(from, to, tt) {
      var yb = [], dmax = 1e-6, i, top = '', bot = '';
      for (i = 0; i <= N; i++) dmax = Math.max(dmax, to[i] - from[i]);
      for (i = 0; i <= N; i++) {
        var ti = 0.45 + 0.55 * Math.max(0, to[i] - from[i]) / dmax; /* peaks touch down first, valleys last */
        LT[i] = ti;
        yb.push(from[i] + (to[i] - from[i]) * ease(clamp(tt / ti)));
      }
      for (i = 0; i <= N; i++) top += (i ? 'L' : 'M') + r1(XS[i]) + ' ' + r1(yb[i] - T);
      for (i = N; i >= 0; i--) bot += 'L' + r1(XS[i]) + ' ' + r1(yb[i]);
      blanket.setAttribute('d', top + bot + 'Z');
      for (i = 0; i < stitches.length; i++) {
        var sx = X0 + (i + 1) * PW, sy = yAt(yb, sx);
        stitches[i].setAttribute('y1', r1(sy - T + 1.5));
        stitches[i].setAttribute('y2', r1(sy - 0.5));
      }
      for (i = 0; i < beads.length; i++) {
        var o = beads[i], rx = X0 + o.p * PW + PW * (o.b + 0.5) / o.n, x = rx, e = 1, ylo;
        if (o.fall) {
          var li = Math.round((o.p + 0.5) * PW / (X1 - X0) * N), bt = clamp((tt - LT[li] * 0.8) / 0.35);
          e = bt < 1 ? 1 - Math.pow(1 - bt, 3) : 1;
          var fx = X0 + o.p * PW + 3 + o.fx * (PW - 6);
          x = fx + (rx - fx) * e;
        }
        ylo = yAt(yb, x);
        var ys = ylo - T + 3 + o.fy * (T - 6), y = o.fall ? ys + ((ylo - 3.4) - ys) * e : ylo - 3.4;
        o.el.setAttribute('cx', r1(x));
        o.el.setAttribute('cy', r1(y));
      }
      return yb;
    }
    /* guard (intro only): checked every 250ms; returning false stops the animation where it is */
    function play(from, to, dur, done, guard) {
      cancelAnimationFrame(raf);
      var start = 0, lastG = 0;
      var step = function (now) {
        if (!start) start = now;
        var tt = clamp((now - start) / dur);
        if (guard && now - lastG > 250) {
          lastG = now;
          if (!guard(tt)) { raf = 0; return; }
        }
        cur = frame(from, to, tt);
        if (tt < 1) { raf = requestAnimationFrame(step); return; }
        raf = 0;
        beads.forEach(function (bd) { bd.fall = false; });
        if (done) done();
      };
      raf = requestAnimationFrame(step);
    }
    function draw(kg) {
      if (!blanket || !beadG) return;
      cancelAnimationFrame(raf);
      raf = 0;
      if (kg == null) kg = 6; /* no class for this body weight: still land the blanket (never left floating) */
      var n = nOf(kg), to = settled(kg);
      if (n !== nBeads) buildBeads(n, false);
      beads.forEach(function (bd) { bd.fall = false; });
      cur = frame(to, to, 1);
    }
    function visual(kg, animate) {
      if (kg == null || !blanket || !beadG) return;
      if (!introDone) return; /* the intro (still ahead) settles on the current recommendation */
      if (!animate || !motionOK() || !cur) { draw(kg); return; }
      var lift = cur.map(function (y) { return y - 12; }), n = nOf(kg); /* GW2-1001 (review): a clearer bounce (PDP: 7) */
      if (n !== nBeads) buildBeads(n, true);
      play(lift, settled(kg), 900);
    }
    function inView(el) { var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < w.innerHeight; }
    function finish() {
      if (hint) hint.classList.remove('is-nudge');
      introDone = true;
      clearTimeout(visT);
      stopWait();
      draw(recKg);
    }
    function nudge() {
      if (touched || !motionOK() || !hint || !inView(card)) return;
      hint.classList.add('is-nudge');
      hint.addEventListener('animationend', function () { hint.classList.remove('is-nudge'); }, { once: true });
    }
    /* GW2-1001 (review): wait until the drawing is really visible (see seen()); polls every 400ms while the tab is visible,
       re-checks right after the cookie choice, gives up after 50 polls (20s): settled state without intro */
    var waitT = 0, waitN = 0, waiting = false;
    function stopWait() {
      waiting = false;
      clearTimeout(waitT);
      waitT = 0;
      d.removeEventListener('visibilitychange', onWaitVis);
      d.removeEventListener('visitorConsentCollected', onConsent);
    }
    function poll() {
      waitT = 0;
      if (!waiting) return;
      if (introDone) { stopWait(); return; }
      if (touched || !motionOK()) { finish(); return; }
      if (d.hidden) return; /* resumes on visibilitychange */
      if (seen(stage)) { stopWait(); intro(waitN > 0); return; }
      if (++waitN > 50) { finish(); return; }
      waitT = setTimeout(poll, 400);
    }
    function onWaitVis() { if (waiting && !d.hidden && !waitT) poll(); }
    function onConsent() { if (!waiting) return; clearTimeout(waitT); waitT = setTimeout(poll, 150); }
    function waitSeen() {
      if (waiting || introDone) return;
      waiting = true;
      d.addEventListener('visibilitychange', onWaitVis);
      d.addEventListener('visitorConsentCollected', onConsent);
      poll();
    }
    function intro(waited) {
      if (introDone || touched || !motionOK()) { finish(); return; }
      var fl = floating();
      /* GW2-1001: on screen at load → let the floating blanket be seen for a moment (it fades in) before it settles; after
         waiting for an overlay (cookie banner) a short pause once it is gone */
      var wait = waited ? 400 : Date.now() - bootT < 500 ? 700 : 250;
      visT = setTimeout(function () {
        if (touched || !motionOK() || recKg == null) { finish(); return; }
        if (!seen(stage)) { waitSeen(); return; } /* covered meanwhile (e.g. the cookie banner appeared) */
        var kg0 = recKg;
        play(fl, settled(kg0), 2600, function () {
          introDone = true;
          if (recKg !== kg0) draw(recKg); /* the selection changed during the intro */
          if (nudgeWait) { nudgeWait = false; nudgeT = setTimeout(nudge, 600); }
        }, function (tt) {
          /* something covers the drawing early in the settle → back to the floating frame, wait again */
          if (tt > 0.6 || seen(stage)) return true;
          buildBeads(nOf(recKg), true);
          cur = frame(fl, fl, 0);
          waitSeen();
          return false;
        });
      }, wait);
    }
    /* own timer: a toggle tapped just before the intro starts must not cancel the intro (visT); visual() waits for it */
    function changed(animate) {
      var before = recKg;
      render(true);
      if (recKg !== before) {
        clearTimeout(chgT);
        chgT = setTimeout(function () { visual(recKg, animate && stage && inView(stage)); }, 120);
      }
    }
    function userInput() {
      touched = true;
      if (hint) hint.classList.remove('is-nudge');
      if (!introDone) finish();
      changed(true);
    }

    /* ---- mode and size */
    /* keep: true = keep the body weight when it lies in the new slider range, 'up' = the next body weight (from the
       children's upper end to the adults), false = the start value of the new range */
    function applyMode(m, keep) {
      var bw = Number(range.value), mm = data.m[m], v = mm.start;
      if (keep === 'up') v = Math.max(mm.min, Math.min(mm.max, bw + 1));
      else if (keep && bw >= mm.min && bw <= mm.max) v = bw;
      mode = m;
      root.classList.toggle('is-kids', m === 'kids');
      range.min = mm.min;
      range.max = mm.max;
      range.value = v;
      if (sLabel) sLabel.textContent = (m === 'kids' && t0.sliderK) || t0.sliderA || sLabel.textContent;
      if (sizeBox) sizeBox.hidden = m === 'kids';
      if (kNote) kNote.hidden = m !== 'kids';
      cta.textContent = m === 'kids' ? t0.ctaK : t0.ctaA;
      cta.setAttribute('href', m === 'kids' ? data.u.kids : data.u.adults);
      whoIn.forEach(function (i) { i.checked = i.value === m; });
    }
    whoIn.forEach(function (inp) {
      inp.addEventListener('change', function () {
        if (!inp.checked || inp.value === mode) return;
        touched = true;
        applyMode(inp.value, true);
        lastKey = '';
        reserve();
        changed(true);
      });
    });
    sizeIn.forEach(function (inp) {
      inp.addEventListener('change', function () {
        if (!inp.checked) return;
        touched = true;
        si = Number(inp.value) || 0;
        reserve();
        changed(true);
      });
    });
    /* children's slider at its upper end: 'Zu den Erwachsenen' switches the finder to adults at the next body weight */
    notes.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-wg-to-adults]') : null;
      if (!btn) return;
      touched = true;
      applyMode('adults', 'up');
      lastKey = '';
      reserve();
      changed(true);
      var a = whoIn.filter(function (i) { return i.value === 'adults'; })[0];
      if (a) { try { a.focus({ preventScroll: true }); } catch (err) { a.focus(); } }
    });

    range.addEventListener('input', userInput);
    range.addEventListener('keydown', function (e) {
      var st = e.key === 'PageUp' ? 10 : e.key === 'PageDown' ? -10 : 0;
      if (!st) return;
      e.preventDefault();
      var v = Math.max(Number(range.min), Math.min(Number(range.max), Number(range.value) + st));
      if (v !== Number(range.value)) { range.value = v; userInput(); }
    });
    onReduce.push({ r: root, f: finish });
    b.fns.push(function () {
      clearTimeout(liveT); clearTimeout(visT); clearTimeout(chgT); clearTimeout(rsT); clearTimeout(nudgeT); cancelAnimationFrame(raf); stopWait();
      w.removeEventListener('resize', onResize);
    });

    /* ---- start: the server start values (the inputs carry autocomplete="off", so no restored state) */
    geom();
    if (!data.a.length) applyMode('kids', false);
    render(false);
    lastW = root.offsetWidth;
    reserve();
    w.addEventListener('resize', onResize, { passive: true });
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { if (root.isConnected) reserve(); });
    /* GW2-1001 (review): a script that runs later than 3s after navigation start (slow connection) skips the intro – the CSS
       fallback reveals the blanket at 3s, so a late floating frame would jump back */
    var late = !!(w.performance && performance.now && performance.now() > 3000);
    if (stage && blanket && beadG && armOK(stage) && recKg != null && !late) {
      var fl = floating();
      buildBeads(nOf(recKg), true);
      cur = frame(fl, fl, 0);
      root.classList.remove('td-wg--arm'); /* GW2-1001: the floating blanket fades in, then settles once really visible */
      once(stage, 0.5, waitSeen, b);
    } else {
      root.classList.remove('td-wg--arm');
      finish();
    }
    /* a gentle hint on the slider once the card is in view (only while untouched, only with motion) */
    /* GW2-1001: while the intro is still ahead or running (drawing right above the slider), the nudge follows the intro */
    once(card, 0.6, function () { if (introDone) nudgeT = setTimeout(nudge, 1200); else nudgeWait = true; }, b);

    /* GW2-1001 (review) — optional (setting "hc", default off, Felix decides): on phones the Smart-Bot chat icon (fixed,
       bottom right) covers the slider's right end. While the drawing or the slider is in view, the class td-wg-chat-off on
       <html> hides it (CSS). Never again on this page view once the visitor has used the chat, never while a chat panel is
       open. */
    if (data.hc && 'IntersectionObserver' in w && w.matchMedia) {
      var phone = w.matchMedia('(max-width: 699px)'), html = d.documentElement, used = false, onScr = {};
      var chatOpen = function () {
        var h = d.getElementById('smart-bot-container'), sr = h && h.shadowRoot;
        if (!sr) return false;
        return [].some.call(sr.querySelectorAll('*'), function (e) { var r = e.getBoundingClientRect(); return r.height > 150 && r.width > 150; });
      };
      var sync = function () {
        var on = !used && phone.matches && (onScr.s || onScr.r) && !chatOpen();
        html.classList.toggle('td-wg-chat-off', !!on);
      };
      var cio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { onScr[e.target === range ? 'r' : 's'] = e.isIntersecting; });
        sync();
      });
      if (stage) cio.observe(stage);
      cio.observe(range);
      var onChat = function (e) {
        var path = e.composedPath ? e.composedPath() : [e.target];
        if (path.some(function (n) { return n && n.id === 'smart-bot-container'; })) { used = true; sync(); }
      };
      d.addEventListener('click', onChat, true);
      if (phone.addEventListener) phone.addEventListener('change', sync);
      b.fns.push(function () {
        cio.disconnect();
        d.removeEventListener('click', onChat, true);
        if (phone.removeEventListener) phone.removeEventListener('change', sync);
        html.classList.remove('td-wg-chat-off');
      });
    }
  }

  /* ---------------------------------------------------------------- boot */
  function safe(fn, root) {
    var b = bag(root);
    try { fn(root, b); } catch (e) {
      root.classList.remove('td-js', 'td-wg--arm'); /* back to the complete server state (no-JS layout) */
      if (w.console && console.warn) console.warn(e);
    }
  }
  function boot(scope) {
    scope = scope || d;
    var list = all(scope, '[data-td-wg]');
    if (scope.matches && scope.matches('[data-td-wg]')) list.unshift(scope);
    list.forEach(function (el) {
      if (el.getAttribute('data-td-init')) return;
      el.setAttribute('data-td-init', '1');
      safe(initGuide, el);
    });
  }
  function cleanup(scope) {
    bags = bags.filter(function (b) {
      if (!scope.contains(b.r)) return true;
      b.fns.forEach(function (f) { try { f(); } catch (e) { /* ignore */ } });
      return false;
    });
    onReduce = onReduce.filter(function (o) { return !scope.contains(o.r); });
  }
  d.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  d.addEventListener('shopify:section:unload', function (e) { cleanup(e.target); });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { boot(d); }); else boot(d);
})();
